import { type ReactNode } from 'react';
import { type ValuePropComponentTheme } from '../../defs/valueProp';
import styles from './ValuePropCard.module.css';

interface Props {
  testid?: string;
  icon: ReactNode;
  text: ReactNode;
  theme: ValuePropComponentTheme;
  className?: string;
}

export function ValuePropCard({ testid, icon, text, theme, className }: Props) {
  return (
    <div data-testid={testid} className={`${styles[theme]} ${className}`}>
      {icon}
      <span data-testid={`${testid}-copy`}>{text}</span>
    </div>
  );
}
